import { render, staticRenderFns } from "./dialogQRCode.vue?vue&type=template&id=5b810906&scoped=true&"
import script from "./dialogQRCode.vue?vue&type=script&lang=js&"
export * from "./dialogQRCode.vue?vue&type=script&lang=js&"
import style0 from "./dialogQRCode.vue?vue&type=style&index=0&id=5b810906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b810906",
  null
  
)

export default component.exports